import { Component, inject, OnInit } from '@angular/core';
import { LoginFormComponent } from '../../molecules/login-form/login-form.component';
import { ActiveUserStore } from '../../../stores/user/active-user.state';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [LoginFormComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  readonly userStore = inject(ActiveUserStore);

  async ngOnInit() {
    this.userStore.isLoginActive();
  }
}
